import { styled } from "@mui/material";

const LogoImage = styled("img")({
  width: "120px",
  marginLeft: "5px",
  marginTop: "-9px",
});

export default function Logo() {
  return <LogoImage src="/img/floats-white.svg" alt="Floats" />;
}
